module.exports = __webpack_public_path__ + "img/smile-okay.732e0451.svg";